import update from 'immutability-helper';
import {
  LoadUserAction,
  LoadUsersListAction,
  ProcessUserAction,
  ResetPasswordCompleteAction,
  ResetPasswordErrorAction,
  ScanUserBarcodeAction,
  SetUserAction,
  UserManagementErrorAction,
  SetCreateUserStatusAction
  } from './actions';
import { createCase, createSwitch } from 'helpers/action-helpers';
import { initialState } from './state';
import { SetRowsAction } from 'components/user-grid/actions';
import { User } from 'types/user';

export const userManagementReducer = createSwitch(initialState, [
  createCase(new SetUserAction({} as User), (state, action) => {
    return update(state, {
      user: { $set: action.user },
      deleteErrorMessage: { $set: '' },
      errorMessage: { $set: '' },
      isLoadingUser: { $set: false },
      isProcessing: { $set: false }
    });
  }),
  createCase(new ScanUserBarcodeAction(''), (state, action) => {
    return update(state, {
      barcode: { $set: action.barcode }
    });
  }),
  createCase(new UserManagementErrorAction(''), (state, action) => {
    return update(state, {
      errorMessage: { $set: action.errorMessage },
      isLoadingUser: { $set: false },
      isProcessing: { $set: false },
      requestSuccess: { $set: false }
    });
  }),
  createCase(new LoadUserAction(), (state) => {
    return update(state, {
      isLoadingUser: { $set: true },
      requestSuccess: { $set: undefined }
    });
  }),
  createCase(new LoadUsersListAction(), (state) => {
    return update(state, {
      isLoadingUsersList: { $set: true },
      requestSuccess: { $set: undefined }
    });
  }),
  createCase(new SetRowsAction([]), (state, action) => {
    return update(state, {
      isLoadingUsersList: { $set: false }
    });
  }),
  createCase(new ProcessUserAction(), (state) => {
    const result = update(state, {
      isProcessing: { $set: true },
      requestSuccess: { $set: undefined }
    });
    return result;
  }),
  createCase(new ResetPasswordCompleteAction(), (state, action) => {
    return update(state, {
      isProcessing: { $set: false },
      passwordResetSuccess: { $set: true }
    });
  }),
  createCase(new ResetPasswordErrorAction(''), (state, action) => {
    return update(state, {
      isProcessing: { $set: false },
      passwordResetSuccess: { $set: false },
      passwordResetErrorMessage: { $set: action.message }
    });
  }),
  createCase(new SetCreateUserStatusAction(true), (state, action) => {
    return update(state, {
      requestSuccess: { $set: action.status },
      deleteErrorMessage: { $set: '' },
      errorMessage: { $set: '' },
      isLoadingUser: { $set: false },
      isProcessing: { $set: false }
    });
  })
]);


// WEBPACK FOOTER //
// ./src/pages/user-management/reducer.ts